import React from "react";
import { StyleSheet, View } from "react-native";
import { BarCodeScanner } from "expo-barcode-scanner";
import { BarCodeScanningResult, Camera } from "expo-camera";
import { ArButton } from "../argon-ui";
import { translate } from "../locales/translate";
type Props = {
  onBarCodeScanned: (scanningResult: BarCodeScanningResult) => void | undefined;
  onCancelScanning: () => void;
  style?: any;
};

const ScannerCamera = (props: Props) => {
  const { onCancelScanning, onBarCodeScanned, style } = props;
  return (
    <View style={styles.scanContainer}>
      <View style={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
        <Camera
          barCodeScannerSettings={{
            barCodeTypes: [BarCodeScanner.Constants.BarCodeType.qr],
          }}
          onBarCodeScanned={onBarCodeScanned}
          style={[{ minHeight: 250,width:"100%" }, style]}
        />
      </View>
      <ArButton
        color="muted"
        style={styles.cancelButton}
        onPress={onCancelScanning}
      >
        {translate("app.cancel")}
      </ArButton>
    </View>
  );
};

export default ScannerCamera;

const styles = StyleSheet.create({
  scanContainer: { flex: 1, position: "relative", marginVertical: 10 },
  overlay: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
  cancelButton: {
    position: "relative",
    top: 5,
    alignSelf: "center",
    width: "100%",
    marginBottom:0
    // flex:1
  },
});
